// import * as R from "ramda";
// import Vue from "vue";

export const setAllFiles = (state, payload) => {
    state.allFiles = payload;
};
